//Dependencies
import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

// Components
import ErrorBoundary from './shared/components/ErrorBoundary';

// Routes
import { routes } from './shared/routes';


export default (props) => {
  const routesMap = routes.map((route, i) => (
    <Route key={i} {...route} />
  ));

  const router = (
    <ErrorBoundary>
      <BrowserRouter>
        <Switch>
          {routesMap}
        </Switch>
      </BrowserRouter>
    </ErrorBoundary>
  );

  return (
    <div>
      {router}
    </div>
  );
};
